var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-table",
    { attrs: { basic: "very", celled: "" } },
    [
      _c(
        "sui-table-header",
        [
          _c("sui-table-header-cell"),
          _vm._l(_vm.columns, function (column, index) {
            return _c("sui-table-header-cell", { key: index }, [
              _vm._v(" " + _vm._s(column) + " "),
            ])
          }),
          _c("sui-table-header-cell"),
        ],
        2
      ),
      _vm.personalSecurities
        ? _c(
            "sui-table-body",
            _vm._l(_vm.personalSecurities, function (security, index) {
              return _c(
                "sui-table-row",
                { key: index },
                [
                  _c("sui-table-cell", [_vm._v(_vm._s(index + 1))]),
                  _c("sui-table-cell", [
                    _vm._v(_vm._s(security.Account_Owner__c)),
                  ]),
                  _c("sui-table-cell", [
                    _vm._v(_vm._s(security.Account_Number__c)),
                  ]),
                  _c("sui-table-cell", [
                    _vm._v(_vm._s(security.Account_Type__c)),
                  ]),
                  _c("sui-table-cell", [_vm._v(_vm._s(security.Custodian__c))]),
                  _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                    _c("div", { staticClass: "table-row-menu" }, [
                      _c(
                        "div",
                        { staticClass: "action-icons" },
                        [
                          _c("sui-icon", {
                            staticClass: "edit-icon",
                            attrs: { name: "edit" },
                            on: {
                              click: function ($event) {
                                return _vm.editPersonalSecurity(index)
                              },
                            },
                          }),
                          _c("sui-icon", {
                            staticClass: "trash-icon",
                            attrs: { name: "trash" },
                            on: {
                              click: function ($event) {
                                return _vm.removePersonalSecurity({
                                  index: index,
                                  id: security.Id,
                                })
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _c(
        "sui-table-footer",
        { attrs: { "full-width": "" } },
        [
          _c(
            "sui-table-row",
            [
              _c("sui-table-header-cell"),
              _c(
                "sui-table-header-cell",
                { attrs: { colspan: "5" } },
                [
                  _c("sui-button", {
                    attrs: {
                      type: "button",
                      basic: "",
                      content: "Add",
                      floated: "left",
                      size: "small",
                    },
                    on: { click: _vm.handleSecurityForm },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }